// extracted by mini-css-extract-plugin
module.exports = {"calendar__day-name-labels":"DaysOfWeekHeader_calendar__day-name-labels__dS_pa"};